import { cloneNested } from '@/helpers/helpers'

const teamDefinitionModel = {
  code: '',
  phoneNumber: '',
  allowDriverAsParamedic: false,
  driverOnly: false,
  displayInPlanner: false,
  acceptsFirstAvailableOrders: true,
  types: [],
}
const checklistDictionaryModel = {
  value: '',
  status: false,
}

export default {
  teamDefinition: cloneNested(teamDefinitionModel),
  emptyTeamDefinition: cloneNested(teamDefinitionModel),
  teamDefinitions: [],
  freeTeamDefinitions: [],
  checklistDictionary: cloneNested(checklistDictionaryModel),
  emptyChecklistDictionary: cloneNested(checklistDictionaryModel),
  checklistDictionaries: [],
}
